define([
	"dojo/_base/lang",
	"csi/access/crews",
	"csi/def/Action",
	"csi/state",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginMenu"
], function(lang,crews,Action,state,PluginFactory,ToolbarPluginMenu) {

	return PluginFactory.declare("tableExcelAll", ToolbarPluginMenu, {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "TableExcelAll",

				/*
				* @param {Context} ctx
				* Disable if no data
				*/
				hasAccess: function(ctx) {
					return ctx.view.hasContent() && Action.prototype.hasAccess.call(this, ctx);
				}
			});
			this.defAction.resolve();
		},

		/*
		* @param {Context} ctx
		* Export All to Excel action is only available for System Administrator
		*/
		validatePlugin: function(ctx) {
			return (state.get("admin") || crews.isInRoles(["Change Log Administrator"], ctx.getContextNode())) && !state.get("print");
		}

	});
});
